(function () {
  var cards = document.querySelectorAll("[data-pp-scratch]");
  if (!cards.length) return;

  var RARITY = {
    common: {
      label: "",
      a: "#9aa6b8",
      b: "#d7dde8",
      glow: "rgba(154, 166, 184, 0.85)",
      spark: ["#c5ccd8", "#ffffff", "#8b97ab"],
    },
    rare: {
      label: "Rare",
      a: "#1a73c7",
      b: "#5ec8ff",
      glow: "rgba(26, 115, 199, 0.9)",
      spark: ["#1a73c7", "#7ad7ff", "#ffffff"],
    },
    epic: {
      label: "Epic",
      a: "#7b2cbf",
      b: "#e0aaff",
      glow: "rgba(123, 44, 191, 0.95)",
      spark: ["#7b2cbf", "#c77dff", "#ff9eed"],
    },
    legendary: {
      label: "Legendary",
      a: "#e6a700",
      b: "#fff1a8",
      glow: "rgba(255, 196, 0, 0.95)",
      spark: ["#ffb703", "#ffe566", "#ffffff", "#e30613"],
    },
  };

  var foilCache = {};

  cards.forEach(setup);

    function loadFoilImage(src) {
    if (!src) return Promise.resolve(null);
    if (foilCache[src]) return foilCache[src];
    foilCache[src] = new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.decoding = "async";
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        resolve(null);
      };
      img.src = src;
    });
    return foilCache[src];
  }

  function rarityFromAmount(amount) {
    var digits = String(amount || "").replace(/[^\d.]/g, "");
    var value = parseFloat(digits);
    if (!isFinite(value)) return "common";
    if (value >= 100) return "legendary";
    if (value >= 50) return "epic";
    if (value >= 25) return "rare";
    return "common";
  }

  function applyRarity(root, key) {
    var rarity = RARITY[key] || RARITY.common;
    root.dataset.rarity = key;
    root.style.setProperty("--pp-rarity-a", rarity.a);
    root.style.setProperty("--pp-rarity-b", rarity.b);
    root.style.setProperty("--pp-rarity-glow", rarity.glow);
    var tag = root.querySelector("[data-pp-rarity-label]");
    if (tag) {
      tag.textContent = rarity.label;
      tag.hidden = !rarity.label;
    }
    return rarity;
  }

  function clearFx(root) {
    root.classList.remove(
      "is-revealed",
      "is-animated",
      "is-shaking",
      "is-leaking",
      "is-bursting",
      "is-opened",
      "is-pulsing"
    );
    root.querySelectorAll(
      ".pp-scratch__spark, .pp-scratch__aura, .pp-scratch__leak, .pp-scratch__burst-ring, .pp-scratch__ray"
    ).forEach(function (node) {
      node.remove();
    });
  }

  function setup(root) {
    var canvas = root.querySelector(".pp-scratch__canvas");
    var stage = root.querySelector(".pp-scratch__stage");
    var revealButton = root.querySelector("[data-pp-reveal]");
    if (!canvas || !stage) return;

    var amount = root.getAttribute("data-amount");
    var rarityKey = root.getAttribute("data-rarity") || rarityFromAmount(amount);
    var foilSrc = root.getAttribute("data-foil-image") || "";
    var foilImage = null;
    applyRarity(root, rarityKey);

    if (root.hasAttribute("data-pp-scratch-open")) {
      root.classList.add("is-revealed", "is-opened");
      return;
    }

    var ctx = canvas.getContext("2d", { willReadFrequently: true });
    var drawing = false;
    var scratched = false;
    var last = null;
    var ratio = 1;
    var userTookOver = false;
    var autoplayTimer = null;
    var autoplayRaf = 0;
    var revealTimers = [];
    var wantsAutoplay = root.hasAttribute("data-pp-autoplay");
    var revealing = false;

    function drawCoverImage(img, width, height, pad, yBias) {
      if (!img || !img.width || !img.height) return;
      var maxW = width * (1 - pad * 2);
      var maxH = height * (1 - pad * 2);
      var scale = Math.min(maxW / img.width, maxH / img.height);
      var dw = img.width * scale;
      var dh = img.height * scale;
      var dx = (width - dw) / 2;
      var dy = (height - dh) / 2 + (yBias || 0);
      ctx.drawImage(img, dx, dy, dw, dh);
    }

    function paintLatexGrain(width, height) {
      var count = Math.floor((width * height) / 40);
      for (var i = 0; i < count; i += 1) {
        var x = Math.random() * width;
        var y = Math.random() * height;
        var shade = Math.random();
        if (shade < 0.5) {
          ctx.fillStyle = "rgba(255,255,255," + (0.03 + Math.random() * 0.07) + ")";
        } else {
          ctx.fillStyle = "rgba(70,82,104," + (0.03 + Math.random() * 0.07) + ")";
        }
        ctx.fillRect(x, y, 1, 1);
      }
    }

    function paintFoil() {
      var rect = stage.getBoundingClientRect();
      ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.max(1, Math.round(rect.width * ratio));
      canvas.height = Math.max(1, Math.round(rect.height * ratio));
      canvas.style.width = rect.width + "px";
      canvas.style.height = rect.height + "px";
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      var width = rect.width;
      var height = rect.height;

      // Base silver latex
      var gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, "#a8b1c0");
      gradient.addColorStop(0.3, "#eef1f6");
      gradient.addColorStop(0.55, "#b8c2d0");
      gradient.addColorStop(0.8, "#f7f8fb");
      gradient.addColorStop(1, "#96a1b2");
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, width, height);

      // Soft highlight so coating feels dimensional
      var sheen = ctx.createRadialGradient(
        width * 0.3,
        height * 0.18,
        2,
        width * 0.5,
        height * 0.5,
        Math.max(width, height) * 0.9
      );
      sheen.addColorStop(0, "rgba(255,255,255,0.5)");
      sheen.addColorStop(0.5, "rgba(255,255,255,0.06)");
      sheen.addColorStop(1, "rgba(55,68,88,0.18)");
      ctx.fillStyle = sheen;
      ctx.fillRect(0, 0, width, height);

      // Hero image — large and clear, with a light foil wash on top
      if (foilImage) {
        try {
          ctx.save();
          ctx.globalAlpha = 0.22;
          ctx.globalCompositeOperation = "source-over";
          drawCoverImage(foilImage, width, height, 0.08, -height * 0.02);

          ctx.globalAlpha = 0.92;
          drawCoverImage(foilImage, width, height, 0.08, -height * 0.04);

          ctx.globalAlpha = 0.28;
          ctx.globalCompositeOperation = "soft-light";
          var metal = ctx.createLinearGradient(0, 0, width, height);
          metal.addColorStop(0, "#d7dde8");
          metal.addColorStop(0.45, "#ffffff");
          metal.addColorStop(1, "#9aa6b8");
          ctx.fillStyle = metal;
          ctx.fillRect(0, 0, width, height);
          ctx.restore();
        } catch (err) {
          ctx.restore();
        }
      }

      // Light diagonal coating streaks (don’t overpower the image)
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
      ctx.strokeStyle = "rgba(255,255,255,0.22)";
      ctx.lineWidth = 5;
      for (var x = -height; x < width; x += 22) {
        ctx.beginPath();
        ctx.moveTo(x, height);
        ctx.lineTo(x + height, 0);
        ctx.stroke();
      }

      paintLatexGrain(width, height);

      // Edge vignette = thicker latex at the rim
      var vignette = ctx.createRadialGradient(
        width / 2,
        height / 2,
        Math.min(width, height) * 0.28,
        width / 2,
        height / 2,
        Math.max(width, height) * 0.72
      );
      vignette.addColorStop(0, "rgba(255,255,255,0)");
      vignette.addColorStop(0.7, "rgba(255,255,255,0)");
      vignette.addColorStop(1, "rgba(90,102,120,0.28)");
      ctx.fillStyle = vignette;
      ctx.fillRect(0, 0, width, height);

      // Thin edge bevel
      ctx.strokeStyle = "rgba(255,255,255,0.5)";
      ctx.lineWidth = 2;
      ctx.strokeRect(1, 1, width - 2, height - 2);
      ctx.strokeStyle = "rgba(40,52,72,0.22)";
      ctx.strokeRect(2.5, 2.5, width - 5, height - 5);

      // Compact hint under the art
      var hintY = height * 0.88;
      ctx.fillStyle = "rgba(16, 35, 63, 0.55)";
      ctx.beginPath();
      roundRect(ctx, width / 2 - 52, hintY - 14, 104, 28, 999);
      ctx.fill();
      ctx.fillStyle = "rgba(255,255,255,0.95)";
      ctx.font = "800 11px Nunito, system-ui, sans-serif";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("SCRATCH", width / 2, hintY - 3);
      ctx.font = "700 9px Nunito, system-ui, sans-serif";
      ctx.fillStyle = "rgba(255,255,255,0.78)";
      ctx.fillText("to reveal", width / 2, hintY + 9);
    }

    function roundRect(c, x, y, w, h, r) {
      var rad = Math.min(r, w / 2, h / 2);
      c.moveTo(x + rad, y);
      c.arcTo(x + w, y, x + w, y + h, rad);
      c.arcTo(x + w, y + h, x, y + h, rad);
      c.arcTo(x, y + h, x, y, rad);
      c.arcTo(x, y, x + w, y, rad);
      c.closePath();
    }

    function point(event) {
      var rect = canvas.getBoundingClientRect();
      var source = event.touches ? event.touches[0] : event;
      return { x: source.clientX - rect.left, y: source.clientY - rect.top };
    }

    function scratchTo(next, brush) {
      var size = brush || 46;
      ctx.globalCompositeOperation = "destination-out";
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.lineWidth = size;
      ctx.strokeStyle = "rgba(0,0,0,1)";
      if (last) {
        ctx.beginPath();
        ctx.moveTo(last.x, last.y);
        ctx.lineTo(next.x, next.y);
        ctx.stroke();
      }
      ctx.beginPath();
      ctx.arc(next.x, next.y, size * 0.5, 0, Math.PI * 2);
      ctx.fill();
      last = next;
      scratched = true;
    }

    function clearedEnough(threshold) {
      var need = threshold == null ? 0.42 : threshold;
      try {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0;
        var total = 0;
        for (var i = 3; i < data.length; i += 64) {
          total += 1;
          if (data[i] < 48) clear += 1;
        }
        return total > 0 && clear / total > need;
      } catch (err) {
        // Tainted canvas / zero-size — don't block scratching
        return false;
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
      if (autoplayRaf) {
        cancelAnimationFrame(autoplayRaf);
        autoplayRaf = 0;
      }
    }

    function clearRevealTimers() {
      revealTimers.forEach(clearTimeout);
      revealTimers = [];
    }

    function later(fn, ms) {
      var id = setTimeout(fn, ms);
      revealTimers.push(id);
      return id;
    }

    function resetDemo() {
      stopAutoplay();
      clearRevealTimers();
      revealing = false;
      clearFx(root);
      var live = root.querySelector("[data-pp-live]");
      if (live) live.textContent = "";
      scratched = false;
      last = null;
      drawing = false;
      paintFoil();
      if (wantsAutoplay && !userTookOver) scheduleAutoplay(900);
    }

    function spawnPackFx(rarity) {
      var aura = document.createElement("span");
      aura.className = "pp-scratch__aura";
      stage.appendChild(aura);

      var leak = document.createElement("span");
      leak.className = "pp-scratch__leak";
      stage.appendChild(leak);

      var ring = document.createElement("span");
      ring.className = "pp-scratch__burst-ring";
      stage.appendChild(ring);

      for (var i = 0; i < 12; i += 1) {
        var ray = document.createElement("span");
        ray.className = "pp-scratch__ray";
        ray.style.setProperty("--ray-rot", i * 30 + "deg");
        stage.appendChild(ray);
      }

      for (var s = 0; s < 22; s += 1) {
        var spark = document.createElement("span");
        spark.className = "pp-scratch__spark";
        var angle = (Math.PI * 2 * s) / 22 + (s % 3) * 0.12;
        var distance = 55 + (s % 5) * 22;
        spark.style.setProperty("--x", Math.cos(angle) * distance + "px");
        spark.style.setProperty("--y", Math.sin(angle) * distance + "px");
        spark.style.background = rarity.spark[s % rarity.spark.length];
        spark.style.animationDelay = 0.55 + (s % 6) * 0.03 + "s";
        stage.appendChild(spark);
      }
    }

    function runPackOpen(animate) {
      var rarity = applyRarity(root, rarityKey);
      root.classList.add("is-revealed", "is-animated");
      var live = root.querySelector("[data-pp-live]");
      if (live && amount) {
        live.textContent = rarity.label ? "Revealed " + amount + " · " + rarity.label : "Revealed " + amount;
      }

      if (!animate) {
        root.classList.add("is-opened");
        return;
      }

      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        root.classList.add("is-opened");
        return;
      }

      spawnPackFx(rarity);
      root.classList.add("is-shaking", "is-pulsing");

      later(function () {
        root.classList.remove("is-shaking");
        root.classList.add("is-leaking");
      }, 560);

      later(function () {
        root.classList.add("is-bursting");
      }, 1680);

      later(function () {
        root.classList.add("is-opened");
      }, 1980);

      later(function () {
        root.classList.remove("is-pulsing", "is-leaking");
      }, 5000);
    }

    function doReveal(animate) {
      if (revealing || root.classList.contains("is-opened") || root.classList.contains("is-revealed")) {
        if (!animate && !root.classList.contains("is-opened")) {
          root.classList.add("is-revealed", "is-opened");
        }
        return;
      }
      revealing = true;
      runPackOpen(animate);
    }

    function runAutoplayScratch() {
      if (userTookOver || revealing || root.classList.contains("is-revealed")) return;
      var width = stage.clientWidth;
      var height = stage.clientHeight;
      if (width < 40 || height < 40) {
        scheduleAutoplay(400);
        return;
      }

      var path = [];
      var brush = 30;

      // Continuous zig-zag that advances along the TL → BR diagonal.
      // Side-to-side swings are perpendicular to that diagonal (herringbone).
      var diagLen = Math.sqrt(width * width + height * height);
      var ux = width / diagLen;
      var uy = height / diagLen;
      // Perpendicular unit vector
      var px = -uy;
      var py = ux;

      var start = 0.06 * diagLen;
      var end = 0.94 * diagLen;
      var advance = Math.max(18, diagLen * 0.07);
      var amplitude = Math.min(width, height) * 0.38;
      var along = start;
      var side = 1;
      var safety = 0;

      function pointOn(alongDist, sideDist) {
        var cx = alongDist * ux + width * 0.02;
        var cy = alongDist * uy + height * 0.02;
        // Keep swings inside the stage
        var x = cx + px * sideDist;
        var y = cy + py * sideDist;
        return {
          x: Math.max(3, Math.min(width - 3, x)),
          y: Math.max(3, Math.min(height - 3, y)),
        };
      }

      var first = pointOn(along, -amplitude * 0.15);
      path.push({
        x: first.x + (Math.random() - 0.5) * 2,
        y: first.y + (Math.random() - 0.5) * 2,
        brush: brush,
      });

      while (along < end && safety < 50) {
        safety += 1;
        var nextAlong = Math.min(end, along + advance);
        var fromSide = side * amplitude;
        var toSide = -side * amplitude;

        var steps = 10 + Math.floor(Math.random() * 3);
        for (var s = 1; s <= steps; s += 1) {
          var t = s / steps;
          var eased = t * t * (3 - 2 * t);
          var a = along + (nextAlong - along) * eased;
          var sDist = fromSide + (toSide - fromSide) * eased;
          var pt = pointOn(a, sDist);
          path.push({
            x: Math.max(3, Math.min(width - 3, pt.x + (Math.random() - 0.5) * 3)),
            y: Math.max(3, Math.min(height - 3, pt.y + (Math.random() - 0.5) * 2.5)),
            brush: brush + (Math.random() * 4 - 2),
          });
        }

        along = nextAlong;
        side = -side;
      }

      if (!path.length) {
        doReveal(true);
        return;
      }

      var index = 0;
      last = null;

      function step() {
        if (userTookOver || revealing || root.classList.contains("is-revealed")) return;
        if (index >= path.length) {
          doReveal(true);
          if (wantsAutoplay && !userTookOver) {
            autoplayTimer = setTimeout(resetDemo, 6200);
          }
          return;
        }

        scratchTo(path[index], path[index].brush);
        index += 1;

        if (index > path.length * 0.92 && index % 12 === 0 && clearedEnough(0.36)) {
          doReveal(true);
          if (wantsAutoplay && !userTookOver) {
            autoplayTimer = setTimeout(resetDemo, 6200);
          }
          return;
        }

        autoplayRaf = requestAnimationFrame(step);
      }

      autoplayRaf = requestAnimationFrame(step);
    }

    function scheduleAutoplay(delay) {
      stopAutoplay();
      if (!wantsAutoplay || userTookOver) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      autoplayTimer = setTimeout(runAutoplayScratch, delay);
    }

    function down(event) {
      if (revealing || root.classList.contains("is-revealed")) return;
      userTookOver = true;
      stopAutoplay();
      root.classList.remove("is-demo");
      drawing = true;
      last = null;
      scratchTo(point(event));
      if (canvas.setPointerCapture && event.pointerId != null) {
        canvas.setPointerCapture(event.pointerId);
      }
    }

    function move(event) {
      if (!drawing) return;
      if (event.cancelable) event.preventDefault();
      scratchTo(point(event));
      if (clearedEnough()) doReveal(true);
    }

    function up() {
      drawing = false;
      last = null;
    }

    paintFoil();
    loadFoilImage(foilSrc).then(function (img) {
      foilImage = img;
      if (!scratched && !root.classList.contains("is-revealed")) paintFoil();
    });
    window.addEventListener("resize", function () {
      if (!scratched && !root.classList.contains("is-revealed")) paintFoil();
    });

    canvas.addEventListener("pointerdown", down);
    canvas.addEventListener("pointermove", move);
    canvas.addEventListener("pointerup", up);
    canvas.addEventListener("pointercancel", up);
    canvas.addEventListener("touchstart", down, { passive: true });
    canvas.addEventListener("touchmove", move, { passive: false });
    canvas.addEventListener("touchend", up);

    if (revealButton) {
      revealButton.addEventListener("click", function () {
        userTookOver = true;
        stopAutoplay();
        doReveal(true);
      });
    }

    var buyLink = root.querySelector(".pp-scratch__buy");
    if (buyLink) {
      buyLink.addEventListener("click", function (event) {
        var variantId = buyLink.getAttribute("data-variant-id");
        var radio = variantId
          ? document.querySelector('input[data-variant-id="' + variantId + '"]')
          : null;
        if (!radio) return;

        event.preventDefault();
        userTookOver = true;
        stopAutoplay();
        radio.checked = true;
        radio.dispatchEvent(new Event("change", { bubbles: true }));
        radio.click();
        if (radio.scrollIntoView) {
          radio.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    }

    if (wantsAutoplay) {
      root.classList.add("is-demo");
      scheduleAutoplay(700);
    }
  }

})();
